import React from 'react';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';
import LinkBlocked from './pages/LinkBlocked';
import Pricing from './pages/Pricing';
import AppsDirectory from './pages/AppsDirectory';
import MRXSolutions from './pages/MRX/MRXSolutions';
import Solutions from './pages/Solutions';

const App = () => {
  return (
    <Switch>
      <Route path="/link-blocked/" component={LinkBlocked} />
      <Route path="/pricing*" component={Pricing} />
      <Route path="/apps*" component={AppsDirectory} />
      <Route path="/market-research/solutions/" component={Solutions} />
      {/* Temp path for MRX marketplace (this will eventually replace solutions) */}
      <Route path="/market-research/our-solutions/" component={MRXSolutions} />
    </Switch>
  );
};

export default App;
